export default __webpack_public_path__ + "static/media/iam_l2.f386c0d1.png";